import {Component, OnInit, Input } from '@angular/core';
import { RadioboxModel } from '../radiobox.model';

@Component({
    selector: 'abw-radiobox-result',
    templateUrl: './radiobox-result.component.html',
    styleUrls: ['./radiobox-result.component.scss']
})
export class RadioboxResultComponent implements OnInit {
	@Input() model: RadioboxModel;
    @Input() value: any;

    constructor(
    ) {
    }

    ngOnInit() {
    }
}